import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { enterpriseApiClient } from '../../client';
import { IndyODataApi } from '../../openapi';
import { db } from '@db/database';
import type { RepairPartViewModelODataResponseViewModel } from '../../openapi';
import type { RepairPartsSearchRequest } from '../types';
import { repairPartsKeys } from '../constants';
import { CACHE_TIMINGS } from '@api/constants';

export const useRepairPartsSearch = (
  searchParams: RepairPartsSearchRequest = {},
  enabled = true
) => {
  const indyODataApi = new IndyODataApi(
    undefined,
    undefined,
    enterpriseApiClient
  );

  const queryKey = useMemo(() => {
    const { filter, select, orderBy, top, skip, includeCount } = searchParams;
    return repairPartsKeys.search({
      filter,
      select: select?.join(','),
      orderBy,
      top,
      skip,
      includeCount
    });
  }, [searchParams]);

  return useQuery<RepairPartViewModelODataResponseViewModel, Error>({
    queryKey,
    queryFn: async () => {
      const { filter, select, orderBy, top, skip, includeCount } = searchParams;

      try {
        const response = await indyODataApi.apiOdataRepairPartsGet({
          $filter: filter,
          $select: select?.join(','),
          $orderby: orderBy,
          $top: top,
          $skip: skip,
          $count: includeCount
        });
        return response.data;
      } catch (error) {
        if (!navigator.onLine) {
          const cachedParts = await db.cachedRepairParts.toArray();
          return {
            value: cachedParts
          } as RepairPartViewModelODataResponseViewModel;
        }
        throw error;
      }
    },
    enabled,
    ...CACHE_TIMINGS.ODATA_SEARCH
  });
};
